import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { currentSession, sageStatus, verifactuChain } from "./api";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("tpv_user") || "null");
    } catch {
      return null;
    }
  });
  const [token, setToken] = useState(() => localStorage.getItem("tpv_token") || null);
  const [session, setSession] = useState(null);
  const [sage, setSage] = useState({ online: true, label: "Sage 200c · …", pending_queue: 0 });
  const [chain, setChain] = useState({ valid: true, total_records: 0 });

  const refreshSession = useCallback(async () => {
    if (!user) {
      setSession(null);
      return null;
    }
    try {
      const s = await currentSession(user.id);
      setSession(s);
      return s;
    } catch {
      setSession(null);
      return null;
    }
  }, [user]);

  const refreshSage = useCallback(async () => {
    try {
      setSage(await sageStatus());
    } catch (e) {
      // ignore
    }
  }, []);

  const refreshChain = useCallback(async () => {
    try {
      setChain(await verifactuChain());
    } catch {
      // ignore
    }
  }, []);

  // Persist auth
  useEffect(() => {
    if (user) localStorage.setItem("tpv_user", JSON.stringify(user));
    else localStorage.removeItem("tpv_user");
  }, [user]);
  useEffect(() => {
    if (token) localStorage.setItem("tpv_token", token);
    else localStorage.removeItem("tpv_token");
  }, [token]);

  // Initial fetch + polling de estado Sage / chain
  useEffect(() => {
    refreshSession();
    refreshSage();
    refreshChain();
    const id = setInterval(() => {
      refreshSage();
      refreshChain();
    }, 15000);
    return () => clearInterval(id);
  }, [refreshSession, refreshSage, refreshChain]);

  const logout = () => {
    setUser(null);
    setToken(null);
    setSession(null);
  };

  return (
    <AppCtx.Provider
      value={{
        user,
        token,
        session,
        sage,
        chain,
        setUser,
        setToken,
        setSession,
        refreshSession,
        refreshSage,
        refreshChain,
        logout,
      }}
    >
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => {
  const ctx = useContext(AppCtx);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};
